<template>
  <div
    class="flex flex-col items-center justify-center w-full px-6 py-16 mx-0 text-center"
  >
    <empty-state-art
      v-if="variant"
      :variant="variant"
      :size="artSize"
      class="mb-8"
    />
    <h3
      v-if="title"
      class="w-full max-w-md text-lg font-semibold tracking-tight text-slate-800 dark:text-slate-75"
    >
      {{ title }}
    </h3>
    <p
      v-if="message"
      class="w-full max-w-md mx-auto mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300"
    >
      {{ message }}
    </p>
    <div v-if="$slots.default" class="mt-6">
      <slot />
    </div>
  </div>
</template>
<script>
import EmptyStateArt from 'dashboard/components/illustrations/EmptyStateArt.vue';

export default {
  components: { EmptyStateArt },
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    // Art is opt-in. Most callers of this component render inside a table or a
    // narrow panel where an illustration would crowd the row it replaces; the
    // ones that own a whole screen ask for it explicitly.
    variant: { type: String, default: '' },
    artSize: { type: String, default: 'md' },
  },
};
</script>
